import { render, staticRenderFns } from "./SendNotificationTab.vue?vue&type=template&id=fb582798&scoped=true"
import script from "./SendNotificationTab.vue?vue&type=script&lang=js"
export * from "./SendNotificationTab.vue?vue&type=script&lang=js"
import style0 from "./SendNotificationTab.vue?vue&type=style&index=0&id=fb582798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb582798",
  null
  
)

export default component.exports